var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"bottomLeftBtm"}},[_c('div',{staticClass:"bg-color-black"},[_c('myTitle',{attrs:{"icon":'plug'}},[_vm._v("累积耗电")]),_c('div',{staticClass:"d-flex jc-center body-box pl-1 pr-1"},[_c('bottomLeftChart')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }